import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { DaysInWeek, Recurrence } from '../../../components/calendars/calendars.models';
import { CommonDataService } from '../../services/common-data.service';
import { CommonService } from '../../services/common.service';
import { LoggerService } from '../../services/logger.service';
import { SelectableChipsComponent } from '../selectable-chips/selectable-chips.component';

@Component({
  selector: 'recurrence',
  templateUrl: './recurrence.component.html',
  styleUrls: ['./recurrence.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, MatDialogTitle, MatRadioModule, MatFormFieldModule, MatInputModule, SelectableChipsComponent, MatDatepickerModule, MatDialogActions, MatButtonModule]
})
export class RecurrenceComponent implements OnInit
{
  public form: FormGroup;

  public RangeTypeNoEndDate = 1;
  public RangeTypeEndAfter = 2;
  public RangeTypeEndBy = 3;

  public EveryWeekDaySelectValue = 2;

  public OnSpecificDayOfMonthSelectValue = 1;

  public previousDaysInTheWeek: DaysInWeek[] = [];

  public IsYearlyOnSpecificDayOfMonth = false;

  public dayOfWeekPatternStartDate: DaysInWeek;

  public specificInstance: string = "specificday";

  public instanceOfStartDate: number;

  constructor(private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private dialogRef: MatDialogRef<RecurrenceComponent>,
    @Inject(MAT_DIALOG_DATA) private data: Recurrence,
    public commonService: CommonService,
    public commonDataService: CommonDataService,
    private loggerService: LoggerService)
  {
    if (this.data)
    {
      if (this.data.PatternEndDate)
      {
        this.data.PatternEndDate = this.commonService.parseJsonDate(this.data.PatternEndDate);
      }
      else
      {
        this.data.PatternEndDate = this.commonService.today;
      }

      if (this.data.PatternStartDate)
      {
        this.data.PatternStartDate = this.commonService.parseJsonDate(this.data.PatternStartDate);
      }
      else
      {
        this.data.PatternStartDate = this.commonService.today;
      }

      const startDateCtrl = this.fb.control({ value: this.data.PatternStartDate, disabled: false });
      const endDateCtrl = this.fb.control({ value: this.data.PatternEndDate, disabled: false });

      this.dayOfWeekPatternStartDate = this.commonDataService.daysInTheWeek.filter(d => d.DayOfWeek == this.data.PatternStartDate.getDay())[0];

      if (!this.data.RecurrenceType)
      {
        this.data.RecurrenceType = this.commonService.RecurrenceTypeNone;
      }
      if (!this.data.Interval)
      {
        this.data.Interval = 1;
      }

      if (!this.data.Occurrences)
      {
        this.data.Occurrences = 0;
      }

      if (this.data.DaysOfWeek && this.data.RecurrenceType == this.commonService.RecurrenceTypeWeekly)
      {
        const days: DaysInWeek[] = this.commonDataService.daysInTheWeek.filter(d => (this.data.DaysOfWeek & d.Value) == d.Value);

        if (days != null && days.length > 0)
        {
          this.data.SelectedDaysInWeek = days;
        }
      }

      if (!this.data.SelectedDaysInWeek || this.data.SelectedDaysInWeek.length < 1)
      {
        this.data.SelectedDaysInWeek = [];
        this.data.SelectedDaysInWeek.push(this.dayOfWeekPatternStartDate);
      }

      this.previousDaysInTheWeek = this.data.SelectedDaysInWeek;



      if (this.data.EndAfter == null)
      {
        this.data.EndAfter = false;
      }
      if (this.data.EndBy == null)
      {
        this.data.EndBy = false;
      }
      if (this.data.EveryWeekDay == null)
      {
        this.data.EveryWeekDay = false;
      }
      if (this.data.NoEndDate == null)
      {
        this.data.NoEndDate = false;
      }
      if (this.data.OnSpecificDayOfMonth == null)
      {
        this.data.OnSpecificDayOfMonth = true;
      }
      if (!this.data.EndBy && !this.data.EndAfter && !this.data.NoEndDate)
      {
        this.data.NoEndDate = true;
      }

      this.data.DaysOfWeek = this.dayOfWeekPatternStartDate.Value;
      this.data.DayOfMonth = this.data.PatternStartDate.getDate();
      this.data.MonthOfYear = this.data.PatternStartDate.getMonth() + 1;  //month is zero indexed

      if (!this.data.OnSpecificDayOfMonth)
      {
        if (this.data.Instance == -1)
        {
          this.specificInstance = "last";
        }
        else
        {
          this.specificInstance = "instance";
        }
      }

      this.form = this.fb.group({
        Id: [this.data.Id, Validators.required],
        PatternEndDate: endDateCtrl,
        PatternStartDate: startDateCtrl,
        RecurrenceType: [this.data.RecurrenceType],
        Interval: [this.data.Interval],
        DayOfMonth: [this.data.DayOfMonth],
        Instance: [this.data.Instance],
        SelectedDaysInWeek: [this.data.SelectedDaysInWeek],
        DaysOfWeek: [this.data.DaysOfWeek],
        EndAfter: [this.data.EndAfter],
        EndBy: [this.data.EndBy],
        EveryWeekDay: [this.data.EveryWeekDay],
        NoEndDate: [this.data.NoEndDate],
        OnSpecificDayOfMonth: [this.data.OnSpecificDayOfMonth],
        Occurrences: [this.data.Occurrences],
        MonthOfYear: [this.data.MonthOfYear],
        MaximumMonths: [this.data.MaximumMonths]
      });

      this.setControls(this.data.RecurrenceType);

      if (this.data.NoEndDate)
      {
        this.form.get('Occurrences').disable({ emitEvent: false });
        this.form.get('PatternEndDate').disable({ emitEvent: false });
      }
      if (this.data.EndBy)
      {
        this.form.get('Occurrences').disable({ emitEvent: false });
        this.form.get('PatternEndDate').enable({ emitEvent: false });
      }
      if (this.data.EndAfter)
      {
        this.form.get('Occurrences').enable({ emitEvent: false });
        this.form.get('PatternEndDate').disable({ emitEvent: false });
      }

      this.instanceOfStartDate = this.commonService.getDayInstanceInMonthForDate(this.data.PatternStartDate);
    }
  }

  ngOnInit(): void
  {

  }

  setControls(recurrenceType: number)
  {
    switch (recurrenceType)
    {
      case this.commonService.RecurrenceTypeDaily:
        if (this.form.get('EveryWeekDay').value)
        {
          this.form.get('Interval').disable({ emitEvent: false });
          this.form.controls["Interval"].patchValue(1);
        }
        else
        {
          this.form.get('Interval').enable({ emitEvent: false });
        }

        break;
      case this.commonService.RecurrenceTypeWeekly:
        this.form.get('Interval').enable({ emitEvent: false });
        break;
      case this.commonService.RecurrenceTypeMonthly:
        this.form.get('Interval').enable({ emitEvent: false });
        break;
      case this.commonService.RecurrenceTypeYearly:
        this.form.get('Interval').enable({ emitEvent: false });
        break;
    }
  }

  recurrenceTypeChanged(event: any)
  {
    if (event && event.value != null)
    {
      this.form.controls["Interval"].patchValue(1);

      if (event.value != this.commonService.RecurrenceTypeWeekly)
      {
        if (this.form.controls["SelectedDaysInWeek"].value)
        {
          this.previousDaysInTheWeek = this.form.controls["SelectedDaysInWeek"].value;
        }
      }

      switch (event.value)
      {
        case this.commonService.RecurrenceTypeNone:
          this.resetToNoRecurrenceDefaults();
          break;
        case this.commonService.RecurrenceTypeDaily:
          break;
        case this.commonService.RecurrenceTypeWeekly:
          this.form.controls["SelectedDaysInWeek"].patchValue(this.previousDaysInTheWeek);
          break;
        case this.commonService.RecurrenceTypeMonthly:
          this.form.controls["DaysOfWeek"].patchValue(this.dayOfWeekPatternStartDate.Value);
          break;
        case this.commonService.RecurrenceTypeYearly:
          this.form.controls["DaysOfWeek"].patchValue(this.dayOfWeekPatternStartDate.Value);
          break;
      }

      this.setControls(event.value);

      this.form.markAsDirty();
    }
  }

  dailySelectionChanged(event: any)
  {
    if (event && event.value != null)
    {
      this.form.controls["EveryWeekDay"].patchValue(event.value == this.EveryWeekDaySelectValue);

      this.setControls(this.commonService.RecurrenceTypeDaily);

      this.form.markAsDirty();
    }
  }


  monthlySelectionChanged(event: any)
  {
    if (event && event.value != null)
    {
      switch (event.value)
      {
        case "specificday":
          this.form.controls["OnSpecificDayOfMonth"].patchValue(true);
          break;
        case "instance":
          this.form.controls["OnSpecificDayOfMonth"].patchValue(false);
          break;
        case "last":
          //last specified day of the month
          this.form.controls["OnSpecificDayOfMonth"].patchValue(false);
          this.form.controls["Instance"].patchValue(-1);
          break;
        default:
          this.form.controls["OnSpecificDayOfMonth"].patchValue(true);
          break;
      }

      this.specificInstance = event.value;

      this.setControls(this.commonService.RecurrenceTypeMonthly);

      this.form.markAsDirty();
    }
  }

  yearlySelectionChanged(event: any)
  {
    if (event && event.value != null)
    {
      switch (event.value)
      {
        case "specificday":
          this.form.controls["OnSpecificDayOfMonth"].patchValue(true);
          break;
        case "instance":
          this.form.controls["OnSpecificDayOfMonth"].patchValue(false);
          break;
        case "last":
          //last specified day of the month
          this.form.controls["OnSpecificDayOfMonth"].patchValue(false);
          this.form.controls["Instance"].patchValue(-1);
          break;
        default:
          this.form.controls["OnSpecificDayOfMonth"].patchValue(true);
          break;
      }

      this.specificInstance = event.value;

      this.setControls(this.commonService.RecurrenceTypeYearly);

      this.form.markAsDirty();
    }
  }

  rangeTypeChanged(event: any)
  {
    if (event && event.value != null)
    {
      this.form.controls["NoEndDate"].patchValue(event.value == this.RangeTypeNoEndDate);
      this.form.controls["EndBy"].patchValue(event.value == this.RangeTypeEndBy);
      this.form.controls["EndAfter"].patchValue(event.value == this.RangeTypeEndAfter);

      switch (event.value)
      {
        case this.RangeTypeNoEndDate:
          this.form.controls["Occurrences"].patchValue(0);
          this.form.get('Occurrences').disable();
          this.form.get('PatternEndDate').disable({ emitEvent: false });
          break;
        case this.RangeTypeEndBy:
          this.form.controls["Occurrences"].patchValue(0);
          this.form.get('Occurrences').disable({ emitEvent: false });
          this.form.get('PatternEndDate').enable({ emitEvent: false });
          break;
        case this.RangeTypeEndAfter:
          if (!this.form.controls["Occurrences"].value || this.form.controls["Occurrences"].value < 1)
          {
            this.form.controls["Occurrences"].patchValue(10);
          }

          this.form.get('Occurrences').enable({ emitEvent: false });
          this.form.get('PatternEndDate').disable({ emitEvent: false });
          break;
      }

      this.form.markAsDirty();
    }
  }

  occurrenceChange(event: any)
  {
    if (this.form.controls["EndAfter"].value && (!this.form.controls["Occurrences"].value || this.form.controls["Occurrences"].value < 1))
    {
      this.form.controls["Occurrences"].patchValue(1);
    }
  }

  resetToNoRecurrenceDefaults()
  {
    this.form.controls["EveryWeekDay"].patchValue(false, { emitEvent: false });
    this.form.controls["Interval"].patchValue(1, { emitEvent: false });
    this.form.controls["EndBy"].patchValue(true, { emitEvent: false });
    this.form.controls["EndAfter"].patchValue(false, { emitEvent: false });
    this.form.controls["NoEndDate"].patchValue(false, { emitEvent: false });
    this.form.controls["OnSpecificDayOfMonth"].patchValue(true, { emitEvent: false });
  }

  resetPatternStartDateRelatedValues()
  {
    const newStartDate: Date = this.form.get("PatternStartDate").value;

    this.dayOfWeekPatternStartDate = this.commonDataService.daysInTheWeek.filter(d => d.DayOfWeek == newStartDate.getDay())[0];

    this.form.controls["DaysOfWeek"].patchValue(this.dayOfWeekPatternStartDate.Value, { emitEvent: false });
    this.form.controls["Instance"].patchValue(this.commonService.getDayInstanceInMonthForDate(newStartDate), { emitEvent: false });
    this.form.controls["DayOfMonth"].patchValue(newStartDate.getDate(), { emitEvent: false });
    this.form.controls["MonthOfYear"].patchValue(newStartDate.getMonth() + 1, { emitEvent: false });  //month is zero indexed


    if (this.form.get("RecurrenceType").value == this.commonService.RecurrenceTypeWeekly)
    {
      const days: DaysInWeek[] = this.commonDataService.daysInTheWeek.filter(d => (this.form.get("DaysOfWeek").value & d.Value) == d.Value);

      if (days != null && days.length > 0)
      {
        this.form.controls["SelectedDaysInWeek"].patchValue(days, { emitEvent: false });
      }
    }
    else
    {
      this.form.controls["SelectedDaysInWeek"].patchValue([this.dayOfWeekPatternStartDate], { emitEvent: false });
    }

    this.previousDaysInTheWeek = this.data.SelectedDaysInWeek;

    this.instanceOfStartDate = this.commonService.getDayInstanceInMonthForDate(this.form.get("PatternStartDate").value);

    if (this.specificInstance == "instance" && (this.instanceOfStartDate == -1 || this.instanceOfStartDate == 5))
    {
      this.specificInstance = "last";
    }
    else if (this.specificInstance == "last" && (this.instanceOfStartDate > 0 && this.instanceOfStartDate < 4))
    {
      this.specificInstance = "instance";
    }

    this.cdr.detectChanges();
  }

  onCancelClick(): void
  {
    this.dialogRef.close();
  }

  startDateChange(event: MatDatepickerInputEvent<Date>)
  {
    if (this.form.get("PatternStartDate").value > this.form.get("PatternEndDate").value)
    {
      //Ensure PatternStartDate is not greater than PatternEndDate
      this.form.controls["PatternEndDate"].patchValue(this.form.get("PatternStartDate").value, { emitEvent: false });
    }

    this.resetPatternStartDateRelatedValues();
  }

  endDateChange(event: MatDatepickerInputEvent<Date>)
  {
    if (this.form.get("PatternStartDate").value > this.form.get("PatternEndDate").value)
    {
      //Ensure PatternStartDate is not greater than PatternEndDate
      this.form.controls["PatternStartDate"].patchValue(this.form.get("PatternEndDate").value, { emitEvent: false });

      this.resetPatternStartDateRelatedValues();
    }
  }

  onSave(): void
  {
    const recurrence: Recurrence = this.form.getRawValue();

    this.commonService.processRecurrence(recurrence, this.specificInstance);

    this.dialogRef.close(recurrence);
  }


 




























}
